// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"a9518ba4","453":"9eb00ecb","680":"3c5f4f3b"}[chunkId] + ".chunk.js";
};